import React from "react";
import Link from "next/link";
import { useTranslations } from '../../locales/useTranslations';
import { BiSolidEnvelope } from "react-icons/bi";

const ItConsultingKmuMainBanner = () => {
  const { t } = useTranslations();

  return (
    <>
      <div className="mainbanner">
        <div className="it-consulting-banner">
          <div className="container">
            <div className="it-consulting-banner-content">
              <h1
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-duration="1200"
                dangerouslySetInnerHTML={{ __html: t('itConsulting_header_title') }}
              />
              <p data-aos="fade-up" data-aos-delay="200" data-aos-duration="1200" dangerouslySetInnerHTML={{ __html: t('itConsulting_header_description') }} />
              <div
                data-aos="fade-up"
                data-aos-delay="300"
                data-aos-duration="1200"
              >
                <Link href="/kontakt" className="default-btn">
                  <BiSolidEnvelope />{t('itConsulting_header_ctaButton')}<span></span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default ItConsultingKmuMainBanner;
